import PropTypes from "prop-types";
import React from "react";
import { useTranslate } from "react-polyglot";
import { Dialog, DialogContent, DialogActions, IconButton, makeStyles, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import checkCircle from "../../../assets/check-circle_2.svg";
import FlatGreyButton from "../../../SharedComponents/FlatGreyButton.jsx";
import { useProductCatalog } from "../../../Providers/Data/ProductCatalogProvider.jsx";
import { useAuth } from "../../../Providers/Auth/AuthProvider.jsx";
import { sourceOffer } from "../../../constants.js";

const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  checkCircle: {
    width: 40,
    height: 40,
  },
  title: {
    fontSize: 24,
    fontWeight: 500,
    color: "#1C1B1F",
    textAlign: "center",
    margin: 20,
  },
  description: {
    fontSize: 18,
    color: "#49454F",
    textAlign: "center",
  },
  closeButton: {
    position: "absolute",
    top: 8,
    right: 8,
  },
  orderButtonBottom: {
    minWidth: 200,
    textTransform: "none",
    borderRadius: 22,
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: theme.spacing(1),
  },
}));

/**
 * Диалог успешного оформления заказа.
 * Для товаров из merch_offers показывает тексты об ожидании связи менеджера,
 * для контента из offers — о мгновенном доступе к покупке.
 *
 * @param {boolean} dialogOpen
 * @param {Function} setDialogOpen
 * @param {?string} offerSource - источник купленного товара (offers или merch_offers)
 * @returns {*}
 * @constructor
 */
const OrderSuccessDialog = ({ dialogOpen, setDialogOpen, offerSource }) => {
  const t = useTranslate();
  const classes = useStyles();
  const { getCoinOffers } = useProductCatalog();
  const { user } = useAuth();

  // Контентные товары (offers) доступны сразу после покупки, мерч-товары требуют обработки менеджером
  const isContentPurchase = offerSource === sourceOffer.offers;
  const titleText = isContentPurchase ? t("productCatalog.thankTextOffer") : t("productCatalog.thankText");
  // Для организации Persona сообщаем об отправке номера накладной по СМС
  const waitMessage = t(user?.companyId === 4472 ? "productCatalog.pleaseWaitPersona" : "productCatalog.pleaseWait");
  const descriptionText = isContentPurchase ? t("productCatalog.contentAvailableText") : waitMessage;

  /** */
  const handleClose = async () => {
    await getCoinOffers();
    setDialogOpen(false);
  };

  return (
    <Dialog maxWidth="xs" open={dialogOpen} onClose={handleClose}>
      <DialogContent className={classes.content}>
        <img className={classes.checkCircle} src={checkCircle} alt="checkCircle" />
        <Typography className={classes.title}>{titleText}</Typography>
        <Typography className={classes.description}>{descriptionText}</Typography>
      </DialogContent>
      <DialogActions>
        <FlatGreyButton className={classes.orderButtonBottom} onClick={handleClose}>
          {t("closeButton")}
        </FlatGreyButton>
      </DialogActions>
      <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
};

OrderSuccessDialog.propTypes = {
  dialogOpen: PropTypes.bool.isRequired,
  setDialogOpen: PropTypes.func.isRequired,
  offerSource: PropTypes.string,
};

export default OrderSuccessDialog;
